export default __webpack_public_path__ + "static/media/sin-lactosa.b89e03b5.svg";